import { POST } from '../Screens/dataSaver';

export const COMPLY_SHIELD_RELAY_KEY = 'complyShieldRelayState';

/**
 * Capture SureShield / Descope RelayState from the current URL as early as possible.
 * Does not change login behavior — only stores the value for post-login redirect.
 */
export const captureComplyShieldRelayState = () => {
  try {
    // Temporary: confirm how Descope returns RelayState on the first real SAML browser test.
    console.log('SSO return URL:', window.location.href);
    const params = new URLSearchParams(window.location.search);
    const relayState = params.get('RelayState');
    if (relayState) {
      sessionStorage.setItem(COMPLY_SHIELD_RELAY_KEY, relayState);
    }
  } catch (error) {
    console.warn('Failed to capture ComplyShield RelayState', error);
  }
};

/**
 * If a RelayState was saved from SureShield SAML, resolve the P&P launch URL and redirect.
 * @returns {Promise<boolean>} true if navigation to P&P was started; false to continue normal redirect.
 */
export const tryComplyShieldSsoRedirect = async () => {
  const relayState = sessionStorage.getItem(COMPLY_SHIELD_RELAY_KEY);
  if (!relayState) return false;

  try {
    const response = await POST(
      'user-management-service/auth/complyshield/sso/resolve',
      { relayState }
    );
    const launchUrl = String(response?.data?.launchUrl || '')
      .trim()
      .replace(/^\//, '');

    if (!launchUrl) {
      sessionStorage.removeItem(COMPLY_SHIELD_RELAY_KEY);
      return false;
    }

    sessionStorage.removeItem(COMPLY_SHIELD_RELAY_KEY);
    window.location.replace(`/${launchUrl}`);
    return true;
  } catch (error) {
    console.warn(
      'ComplyShield SSO resolve failed; falling back to normal redirect',
      error
    );
    sessionStorage.removeItem(COMPLY_SHIELD_RELAY_KEY);
    return false;
  }
};
